import { css } from "../../../../../../styled-system/css";
import { token } from "../../../../../../styled-system/tokens";

export const fullWidthHeightImageStyles = {
  width: "100%",
  height: "100%",
};

export const styles = {
  imageBox: (isFallback: boolean) =>
    css({
      position: "relative",
      marginLeft: `calc(-1 * ${token("spacing.baseUnit.mobile4")})`,
      width: `calc(100% + 2 * ${token("spacing.baseUnit.mobile4")})`,
      aspectRatio: "464 / 348",
      marginTop: 0,
      marginBottom: "baseUnit.mobile1",
      mobile: {
        marginLeft: 0,
        width: "var(--width-for-desktop)",
        height: "var(--height-for-desktop)",
        aspectRatio: "auto",
      },
      ...(isFallback
        ? {
            backgroundColor: "disabledGrey",
          }
        : {
            "&::before": {
              content: '""',
              position: "absolute",
              inset: 0,
              background: "black",
              pointerEvents: "none",
            },
            "&::after": {
              content: '""',
              position: "absolute",
              inset: 0,
              background: "linear-gradient(180deg, rgba(0, 0, 0, 0.50) 11.72%, rgba(0, 0, 0, 0.00) 80%)",
              pointerEvents: "none",
            },
          }),
      "& img": {
        ...(isFallback
          ? undefined
          : {
              width: "100%",
              height: "100%",
              objectFit: "contain",
              position: "relative",
            }),
        margin: "auto",
      },
    }),
  zoomButton: () =>
    css({
      position: "absolute",
      right: "0",
      bottom: "0",
      transform: `translate(-${token("spacing.baseUnit.mobile2")}, -${token("spacing.baseUnit.mobile2")})`,
    }),
  twoFingersHint: (visible: boolean) =>
    css({
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      padding: `${token("spacing.baseUnit.mobile2")} ${token("spacing.baseUnit.mobile3")}`,
      backgroundColor: "rgba(0, 0, 0, 0.88)",
      color: "white",
      borderRadius: "12px",
      fontSize: "17px",
      fontWeight: 600,
      lineHeight: "1.35",
      textAlign: "center",
      textShadow: "0 1px 2px rgba(0, 0, 0, 0.6)",
      boxShadow: "0 4px 16px rgba(0, 0, 0, 0.35)",
      pointerEvents: "none",
      opacity: visible ? 1 : 0,
      transition: "opacity 200ms ease-in-out",
      maxWidth: "85%",
      zIndex: 2,
    }),
};
